import { deleteCookie, getCookie, setCookie } from "@/utils/cookies";
import { APPROVED_COOKIES_COOKIE, ENV_PRODUCTION, ENV_TEST } from "@/utils/variables";

const ACCESS_TOKEN_STORAGE_KEY = "access_token";
const LANGUAGE_TOKEN_STORAGE_KEY = "language";
const VIDEO_QUALITY_STORAGE_KEY = "video_quality";
const TLD_STORAGE_KEY = "tld";
const VOLUME_VALUE_STORAGE_KEY = "volume_value";
export const VISIT_UID_KEY = "vID";

const load = (key: string): any | null => {
  const storage = getStorage();

  const serializedValue = storage?.getItem(key) || getCookie(key);

  if (!serializedValue) {
    return null;
  }

  try {
    return JSON.parse(serializedValue);
  } catch {
    console.warn(key, serializedValue);
    remove(key);
    return null;
  }
};

const set = (key: string, value: any) => {
  if (typeof value !== "undefined") {
    const storage = getStorage();

    if (storage) {
      try {
        storage.setItem(key, JSON.stringify(value));
      } catch {
        setCookie(key, JSON.stringify(value), 365);
      }
    } else {
      setCookie(key, JSON.stringify(value), 365);
    }
  } else {
    remove(key);
  }
};

const remove = (key: string): void => {
  const storage = getStorage();

  if (storage) {
    storage.removeItem(key);
  }

  deleteCookie(key);
};

const getStorage = (): Storage | null => {
  try {
    return localStorage;
  } catch {
    //
  }

  return null;
};

export const loadAccessToken = (): string | null => {
  // todo: temp added because its needed to run experiment to get use on backend
  return ![ENV_PRODUCTION, ENV_TEST].includes(import.meta.env.VITE_ENV) ? load(ACCESS_TOKEN_STORAGE_KEY) : getCookie(ACCESS_TOKEN_STORAGE_KEY);
};

export const getVisitUid = () => {
  return ![ENV_PRODUCTION, ENV_TEST].includes(import.meta.env.VITE_ENV) ? load(VISIT_UID_KEY) : getCookie(VISIT_UID_KEY);
};

export const setVisitUid = (uid: string) => {
  if (![ENV_PRODUCTION, ENV_TEST].includes(import.meta.env.VITE_ENV)) {
    set(VISIT_UID_KEY, uid);
  } else {
    setCookie(VISIT_UID_KEY, uid, 365);
  }
};

export const setAccessToken = (value: string) => {
  if (![ENV_PRODUCTION, ENV_TEST].includes(import.meta.env.VITE_ENV)) {
    set(ACCESS_TOKEN_STORAGE_KEY, value);
  } else {
    setCookie(ACCESS_TOKEN_STORAGE_KEY, value, 365);
  }
};

export const setApprovedCookies = () => {
  set(APPROVED_COOKIES_COOKIE, true);
};

export const getApprovedCookies = (): boolean | null => {
  return load(APPROVED_COOKIES_COOKIE);
};

export const removeAccessToken = () => {
  remove(ACCESS_TOKEN_STORAGE_KEY);
};

export const setLanguage = (language: string) => {
  set(LANGUAGE_TOKEN_STORAGE_KEY, language);
};

export const loadLanguage = () => {
  return load(LANGUAGE_TOKEN_STORAGE_KEY);
};

export const setVideoQuality = (quality: string | number) => {
  set(VIDEO_QUALITY_STORAGE_KEY, quality);
};

export const loadVideoQuality = () => {
  return load(VIDEO_QUALITY_STORAGE_KEY);
};

export const setVolumeValue = (value: number) => {
  set(VOLUME_VALUE_STORAGE_KEY, value);
};

export const loadVolumeValue = () => {
  return load(VOLUME_VALUE_STORAGE_KEY);
};

export const loadTld = () => {
  return load(TLD_STORAGE_KEY);
};

export const setPopup = (id: string, show: boolean, data: Record<string, any> | null = null) => {
  set(id, { show: show, data: data });
};

export const updatePopup = (id: string, data: Record<string, any>) => {
  const popupShow = getPopup(id)?.show ?? false;

  const popupData = getPopup(id)?.data ?? {};
  const newData = { ...popupData, ...data };

  set(id, { show: popupShow, data: newData });
};

export const getPopup = (id: string) => {
  return load(id);
};

export const removePopup = (id: string) => {
  return remove(id);
};
